<template>
  <v-app-bar fixed elevate-on-scroll >
    <router-link to="/">
      <v-img src="../assets/africon_logo.png" width="120" height="40"></v-img>
    </router-link>
  </v-app-bar>
</template>
<script>
export default {
  
}
</script>
<style lang="scss" scoped>

</style>